/* ============
 * Actions for the message module
 * ============
 *
 * The actions that are available on the
 * message module.
 */
import MessageProxy from '@/proxies/MessageProxy';
import types from './mutation-types';

export const fetchPatients = ({ commit }, filter) => {
  commit(types.FETCH_PATIENTS_LIST);
  new MessageProxy().fetchPatients(filter).then((response) => {
    commit(types.FETCH_PATIENTS_LIST_SUCCESS, { response, filter });
  }).catch((error) => {
    commit(types.FETCH_PATIENTS_LIST_FAIL, error);
  });
};

export const fetchPatientMessages = ({ commit }, filter) => {
  commit(types.FETCH_PATIENTS_MESSAGE_LIST);
  new MessageProxy().fetchPatientMessages(filter).then((response) => {
    commit(types.FETCH_PATIENTS_MESSAGE_LIST_SUCCESS, { filter, response });
  }).catch((error) => {
    commit(types.FETCH_PATIENTS_MESSAGE_LIST_FAIL, error);
  });
};

export const sendMessage = ({ commit }, formData) => {
  commit(types.SEND_MESSAGE);
  new MessageProxy().sendMessage(formData).then((response) => {
    commit(types.SEND_MESSAGE_SUCCESS, response);
  }).catch((error) => {
    commit(types.SEND_MESSAGE_FAIL, error);
  });
};

export const getRoomId = ({ commit }, patientId) => {
  return new MessageProxy().getRoomId( patientId ).then((response) => {
    return response;
  }).catch((error) => {
    commit(types.START_VIDEO_CALL_FAIL, error);
  });
};

export const startVideoCall = ({ commit }) => {
  commit(types.START_VIDEO_CALL);
};

export const closeVideoChat = ({ commit }, filter) => {
  new MessageProxy().closeVideoChat(filter);
};

export const saveVideoCallNotes = ({ commit }, filter) => {
  return new MessageProxy().saveVideoCallNotes(filter);
};

export default {
  fetchPatients,
  fetchPatientMessages,
  sendMessage,
  getRoomId,
  startVideoCall,
  closeVideoChat,
  saveVideoCallNotes
};
